const template = {
  name: "Default NEC4 SC v4.2 16/07/2025",
  isSystemDefault: true,
  isGlobal: true,
  companies: [],
  resources: [
    {
      id: 1,
      type: "TEXT",
      key: "SUPPLIER_NAME",
      value: "Supplier"
    },
    {
      id: 2,
      type: "TEXT",
      key: "SUPPLIER_ABBREVIATION",
      value: "SUP"
    },
    {
      id: 3,
      type: "TEXT",
      key: "PM_NAME",
      value: "Supply Manager"
    },
    {
      id: 4,
      type: "TEXT",
      key: "PM_ABBREVIATION",
      value: "SM"
    },
    {
      id: 5,
      type: "TEXT",
      key: "SUPERVISOR_NAME",
      value: "Supply Manager (Supervisor)"
    },
    {
      id: 6,
      type: "TEXT",
      key: "SUPERVISOR_ABBREVIATION",
      value: "SM SUP"
    },
    {
      id: 7,
      type: "TEXT",
      key: "CLIENT_NAME",
      value: "Purchaser"
    },
    {
      id: 8,
      type: "NUMBER",
      key: "SUPPLIER_REPLY_PERIOD",
      value: 14
    },
    {
      id: 9,
      type: "NUMBER",
      key: "PM_REPLY_PERIOD",
      value: 14
    },
    {
      id: 10,
      type: "NUMBER",
      key: "QUOTE_DURATION",
      value: 21
    },
    {
      id: 13,
      type: "NUMBER",
      key: "REQUOTE_DURATION",
      value: 21
    },
    {
      id: 11,
      type: "NUMBER",
      key: "QUOTE_RESPONSE",
      value: 14
    },
    {
      id: 14,
      type: "NUMBER",
      key: "REQUOTE_RESPONSE",
      value: 14
    },
    {
      id: 12,
      type: "NUMBER",
      key: "VARIATION_RESPONSE",
      value: 7
    },
    {
      id: 15,
      type: "NUMBER",
      key: "PAYMENT_PERIOD",
      value: 21
    },
    {
      id: 8,
      type: "TEXT",
      key: "CLIENT_ABBREVIATION",
      value: "P"
    },
    {
      id: 9,
      type: "TEXT",
      key: "COMPLETION_DATE",
      value: "Delivery Date"
    },
    {
      id: 10,
      type: "TEXT",
      key: "QUOTE_DEEMED_ACCEPTANCE_STARTS",
      value: "RELATED_NOTICE"
    },
    {
      id: 25,
      type: "NUMBER",
      key: "QUOTE_DEEMED_ACCEPTANCE",
      value: 14
    },
    {
      id: 39,
      type: "TEXT",
      key: "CEN_DEEMED_ACCEPTANCE_STARTS",
      value: "RELATED_NOTICE"
    },
    {
      id: 40,
      type: "NUMBER",
      key: "CEN_DEEMED_ACCEPTANCE",
      value: 14
    },
    {
      id: 19,
      type: "NUMBER",
      key: "PROGRAMME_REPLY_PERIOD",
      value: 14
    },
    {
      id: 41,
      type: "TEXT",
      key: "PROG_DEEMED_ACCEPTANCE_STARTS",
      value: "RELATED_NOTICE"
    },
    {
      id: 42,
      type: "NUMBER",
      key: "PROG_DEEMED_ACCEPTANCE",
      value: 7
    }
  ],
  workflowGroups: [
    {
      id: 101,
      title: "Early Warnings",
      workflows: [
        {
          id: 1,
          title: "$PM_NAME Early Warnings",
          notificationName: "Early Warning",
          abbreviation: "$PM_ABBREVIATION-Warning-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 2,
          title: "$SUPPLIER_NAME Early Warnings",
          notificationName: "Early Warning",
          abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 3,
          title: "Risk Register",
          notificationName: "Early Warning",
          abbreviation: "Warning",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "MeetingRequiredLabel",
              display: "Is an early warning meeting required?",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "NotificationClause",
              display: "You are given early warning of a matter which could",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "RiskItemsLabel",
              display: "You are given early warning of a matter which could",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskTypes",
          values: [
            {
              id: 1,
              isActive: true,
              field: "riskincreaseprice",
              display: "increase the total of the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "riskdelaycompletion",
              display: "delay Delivery",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "riskimpairperformance",
              display: "impair the performance of the goods in use",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "riskserviceperformance",
              display: "impair the usefulness of the services to the Purchaser",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "riskincreasecontractorcost",
              display: "increase $SUPPLIER_NAME's total cost",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "riskotherpartner",
              display: "affect the achievement of another Partner's objectives (X12.3)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "riskaffectmodel",
              display: "adversely affect the creation or use of the Information Model (X10.3)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "riskenvironment",
              display: "adversely affect the achievement of the Climate Change Requirements (X20.3)",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "MeetingOptions",
          values: [
            {
              id: 1,
              isActive: false,
              field: "0",
              display: "Extra meeting not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "To be discussed at the next scheduled early warning meeting",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Propose early warning meeting",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Pm",
              display: "$WF_1_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Supplier",
              display: "$WF_2_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Client",
              display: "$WF_74_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RiskStatusOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Mitigated",
              display: "Mitigated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "NotMitigated",
              display: "Not mitigated",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 102,
      title: "Instructions",
      workflows: [
        {
          id: 4,
          title: "$PM_NAME Instruction",
          notificationName: "Instruction",
          abbreviation: "$PM_ABBREVIATION-Instruction-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: false,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "InstructionTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "14.3 to change the Scope",
              overrideResources: null,
              postActions: [
                {
                  askUser: true,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_5",
                  timePeriod: "CUSTOM"
                }
              ]
            },
            {
              id: 18,
              isActive: true,
              field: "",
              display: "14.5 to correct a mistake in the Price List",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "",
              display: "15.2 to attend an early warning meeting",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "17.1 to resolve an ambiguity or inconsistency",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "17.2 to change the Scope to remove something which is illegal or impossible",
              overrideResources: null,
              postActions: [
                {
                  askUser: true,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_5",
                  timePeriod: "CUSTOM"
                }
              ]
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "19.1 on how to deal with a prevention event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "32.2 to submit a revised programme",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_14",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "34.1 to stop or not start work",
              overrideResources: null,
              postActions: [
                {
                  askUser: true,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_5",
                  timePeriod: "CUSTOM"
                }
              ]
            },
            {
              id: 17,
              isActive: true,
              field: "",
              display: "34.1 to start or restart work",
              applyReplyPeriod: false,
              noReply: false,
              overrideReplyingParty: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "",
              display: "34.1 to remove work from the Scope",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "35.1 to submit a quotation for acceleration",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_19",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 20,
              isActive: true,
              field: "",
              display: "40.3 to correct a failure to comply with the quality plan",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "43.1 to search for a Defect in the goods and services included in the Delivery",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "",
              display: "62.1 to submit alternative quotations for a compensation event",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "",
              display: "82.1 to not replace or repair damage to the goods",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "85.1 to submit insurance policy information for acceptance",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_18",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "92.2 to leave the Purchaser’s premises and remove equipment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "",
              display: "X12.1(4) providing Partnering Information",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "",
              display: "X29.4(4) to submit a revised climate change plan",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_18",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "Other instruction",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PM",
              display: "$WF_4_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Supervisor",
              display: "$WF_61_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Client",
              display: "$WF_56_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 103,
      title: "Compensation Events",
      workflows: [
        {
          id: 5,
          title: "$PM_NAME Compensation Events",
          notificationName: "Compensation Event",
          abbreviation: "$PM_ABBREVIATION-Compensation-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          quotingParty: "SUPPLIER",
          quoteReplyingParty: "PM",
          quoteNotificationName: "Quote",
          quoteReferencePrefix: "Quote-",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteMainNotice: {
              createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteReplyNotice: {
              saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 6,
          title: "$PM_NAME Proposed Instructions",
          notificationName: "Proposed Instruction",
          abbreviation: "$PM_ABBREVIATION-PROP-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          quotingParty: "SUPPLIER",
          quoteReplyingParty: "PM",
          quoteNotificationName: "Quote",
          quoteReferencePrefix: "Quote-",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteMainNotice: {
              createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteReplyNotice: {
              saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 7,
          title: "$SUPPLIER_NAME Compensation Events",
          notificationName: "Compensation Event",
          abbreviation: "$SUPPLIER_ABBREVIATION-Compensation-",
          notify: true,
          replyEnabled: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "VARIATION_RESPONSE",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          quotingParty: "SUPPLIER",
          quoteReplyingParty: "PM",
          quoteNotificationName: "Quote",
          quoteReferencePrefix: "Quote-",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            quoteMainNotice: {
              createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            quoteReplyNotice: {
              saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 8,
          title: "$PM_NAME CE Assessments",
          notificationName: "Assessment of Compensation Event",
          abbreviation: "$PM_ABBREVIATION-CE-Assessment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 9,
          title: "$PM_NAME Extensions",
          notificationName: "Extension",
          abbreviation: "$PM_ABBREVIATION-Extension-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 10,
          title: "$SUPPLIER_NAME Extensions",
          notificationName: "Extension",
          abbreviation: "$SUPPLIER_ABBREVIATION-Extension-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 11,
          title: "Master Quote Register",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        },
        {
          id: 12,
          title: "Master CE Register",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        },
        {
          id: 13,
          title: "Implemented CE Register",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmAssumptionLabel",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PmAssumptionNote",
              display: "You are instructed to provide a quotation by $date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "SupplierDescNote",
              display: "You are notified of the following event as a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "ReplyAcceptedCommentLabel",
              display: "You are notified of the $PM_NAME's decision that the event notified is a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "ReplyRejectedCommentLabel",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "ReplyAcceptedAssumptionLabel",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "QuoteNote",
              display: "We submit our quotation for compensation event $reference",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "ExtensionPMLabel",
              display: "We require an extension to the contractual time to produce a compensation event quotation response as detailed below for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ExtensionSupplierLabel",
              display: "We require an extension to the contractual time to produce a compensation event quotation as detailed below for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "AssessmentDetailLabel",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ProposedInstructionNote",
              display: "You are instructed to provide a quotation by $date.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "ProposedInstructionLabel",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "ReplyRejectedOptionsLabel",
              display: "You are notified of the $PM_NAME's decision that the event notified is not a compensation event as it",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "QuoteCostEffectLabel",
              display: "Change to the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "QuoteDateEffectLabel",
              display: "Delay to Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "QuoteDaysEffectLabel",
              display: "The length of time that the Delivery Date is delayed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "AssessmentCostEffectLabel",
              display: "Change in the Total of the Prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: true,
              field: "AssessmentDaysEffectLabel",
              display: "Delay to Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "ReplyAcceptedAssumptionNote",
              display: "You instructed to submit a quotation by $date.",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "60.1(1) The $PM_NAME gives an instruction changing the Scope",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "60.1(2) The $CLIENT_NAME does not allow access to the premises",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "60.1(3) The $CLIENT_NAME does not provide something that he is required to provide",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "60.1(4) The $PM_NAME gives an instruction to stop or not start work",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "60.1(5) The $CLIENT_NAME or Others do not work within the stated conditions",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "60.1(6) The $PM_NAME does not reply to a communication",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "60.1(7) The $PM_NAME changes a decision",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "60.1(8) The $PM_NAME withholds an acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "",
              display: "601(9) The $PM_NAME instructs a search for a Defect and no Defect is found",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "",
              display: "60.1(10) A test or inspection by the $PM_NAME causes unnecessary delay",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "60.1(11) $CLIENT_NAME does not provide records and other information or facilities for tests and inspections",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "60.1(12) An event which is the $CLIENT_NAME’s liability",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "",
              display: "60.1(13) $PM_NAME notifies correction of an assumption",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "60.1(14) A breach by the $CLIENT_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "",
              display: "60.1(15) An event occurs during transport of the goods to the Delivery Place",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "",
              display: "60.1(16) The $PM_NAME gives an instruction to correct a mistake in the Price List",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "",
              display: "60.1(17) The $PM_NAME notifies the $SUPPLIER_NAME that a quotation for a proposed instruction is not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              isActive: true,
              field: "",
              display: "60.1(18) Additional compensation events stated in Contract Data part one",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "",
              display: "X2.1 A change in law",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: true,
              field: "",
              display: "X12.3 A change in the Partnering Information",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "",
              display: "X14.2 Delay in making an advanced payment",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyRejectOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "faultpscp",
              display: "arises from a fault of the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "notexpectnothappen",
              display: "has not happened and is not expected to happen",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "noteffectcostcompletion",
              display: "has no effect on Defined Cost or Delivery",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "statedcontract",
              display: "is not one of the compensation events stated in this contract",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "notnotifiedwithintimescales",
              display: "has not been notified within the timescales set out in the contract",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "InstructionReplyProceedOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "61.1",
              display: "61.1 Consultant is instructed to proceed with works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "61.2",
              display: "61.2 Consultant is instructed to NOT proceed with works until instructed",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteProgrammeImpactOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "noeffect",
              display: "There is no effect on the Delivery Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "mitigated",
              display: "There is an effect on the Delivery Date but this has been mitigated by measures as detailed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notmitigated",
              display: "There is an effect on the Delivery Date which we are unable to mitigate",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "EWRelationEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "EWRelationEnabled",
              display: "Active-Inactive state indicates weather the EWN can be attached in CEN communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Assumption",
              display: "The quotation is to be based on the following assumptions",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "InstructionReplyProceedEnabled",
          values: [
            {
              id: 1,
              isActive: false,
              field: "InstructionReplyProceedEnabled",
              display: "Proposed instructions Quote Reply field proceed options Enabled/Disabled",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "InstructionReplyOpts",
          values: [
            {
              id: 1,
              isActive: true,
              field: "1",
              display: "QuoteStatus_1",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "0",
              display: "QuoteStatus_0",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "3",
              display: "QuoteStatus_3",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "5",
              display: "QuoteStatus_5",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaskOrderOptionEnabled",
          values: [
            {
              id: 1,
              isActive: false,
              field: "TaskOrderOptionEnabled",
              display: "Active-Inactive state indicates weather Task-Order can be selected in CEN communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "INTERIM_QUOTES_ALLOWED",
          values: [
            {
              id: 1,
              isActive: false,
              field: "INTERIM_QUOTES_ALLOWED",
              display: "Active-Inactive state indicates whether the continuing effect field is asked on quote communications",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "RelatedCompensationText",
          values: [
            {
              id: 1,
              isActive: true,
              field: "RelatedCompensationText",
              display: "Regarding the aforementioned instruction, you are hereby notified of a compensation event under clause 61.1",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "QuoteStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "0",
              display: "Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "1",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "2",
              display: "Awaiting Response",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "3",
              display: "Not Accepted - $PM_ABBREVIATION to make assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "4",
              display: "Not Accepted - Other quote approved",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "5",
              display: "Not Accepted - Proposed instruction will not be given",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "6",
              display: "Awaiting Deemed Acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "7",
              display: "Deemed Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "none",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "8",
              display: "Acknowledged",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "9",
              display: "Not Accepted - Process ended",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "10",
              display: "Assessed",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationStatuses",
          values: [
            {
              id: 1,
              isActive: true,
              field: "APMA",
              display: "Quote Not Accepted - $PM_ABBREVIATION to make own Assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ARQ",
              display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "AM",
              display: "$PM_ABBREVIATION Assessment Made",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "QA",
              display: "Quote Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "APMRQ",
              display: "Awaiting $PM_ABBREVIATION Response to quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "APMR",
              display: "Awaiting $PM_ABBREVIATION Response to CEN",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "AQ",
              display: "Awaiting Quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NC",
              display: "Not Communicated",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "R",
              display: "Not a Compensation Event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "DNG",
              display: "Proposed instruction will not be given",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "ADAQ",
              display: "Awaiting Deemed Acceptance of Quote",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "DA",
              display: "Deemed Accepted",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmCompensationAQ",
              display: "$WF_5_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PmCompensationARQ",
              display: "$WF_5_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "PmCompensationAPMRQ",
              display: "$WF_5_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "PmCompensationAPMA",
              display: "$WF_5_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "SupCompensationAQ",
              display: "$WF_7_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SupCompensationARQ",
              display: "$WF_7_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "SupCompensationAPMR",
              display: "$WF_7_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "SupCompensationAPMRQ",
              display: "$WF_7_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "SupCompensationAPMA",
              display: "$WF_7_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "PmProposedAQ",
              display: "$WF_6_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "PmProposedARQ",
              display: "$WF_6_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "PmProposedAPMRQ",
              display: "$WF_6_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "PmProposedAPMA",
              display: "$WF_6_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "SupAssumption",
              display: "$WF_42_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "SupClaimAPMR",
              display: "$WF_37_TITLE awaiting reply to notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "SupClaimAQ",
              display: "$WF_37_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "SupClaimARQ",
              display: "$WF_37_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "SupClaimAPMRQ",
              display: "$WF_37_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "SupClaimAPMA",
              display: "$WF_37_TITLE awaiting determination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              isActive: true,
              field: "replydraftpmcequotessupplier",
              display: "$WF_7_TITLE quotations",
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: true,
              field: "COMPENSATION_CWN_APMR",
              display: "$WF_67_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              isActive: true,
              field: "COMPENSATION_CWN_AQ",
              display: "$WF_67_TITLE awaiting reply awaiting full details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 24,
              isActive: true,
              field: "COMPENSATION_CWN_ARQ",
              display: "$WF_67_TITLE awaiting reply awaiting revised details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: true,
              field: "COMPENSATION_CWN_APMRQ",
              display: "$WF_67_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 27,
              isActive: true,
              field: "COMPENSATION_CWN_APMA",
              display: "$WF_67_TITLE awaiting determination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 28,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_AQ",
              display: "$WF_75_TITLE awaiting full details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 29,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_ARQ",
              display: "$WF_75_TITLE awaiting revised details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 30,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_APMR",
              display: "$WF_75_TITLE awaiting reply to notice",
              overrideResources: null,
              postActions: null
            },
            {
              id: 31,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_APMRQ",
              display: "$WF_75_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 32,
              isActive: true,
              field: "COMPENSATION_CLIENTCWN_APMA",
              display: "$WF_75_TITLE awaiting determination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 33,
              isActive: true,
              field: "COMPENSATION_CLIENT_AQ",
              display: "$WF_76_TITLE awaiting quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 34,
              isActive: true,
              field: "COMPENSATION_CLIENT_ARQ",
              display: "$WF_76_TITLE awaiting revised quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 35,
              isActive: true,
              field: "COMPENSATION_CLIENT_APMR",
              display: "$WF_76_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 36,
              isActive: true,
              field: "COMPENSATION_CLIENT_APMRQ",
              display: "$WF_76_TITLE awaiting reply to quotation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 37,
              isActive: true,
              field: "COMPENSATION_CLIENT_APMA",
              display: "$WF_76_TITLE awaiting assessment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "PmExtension",
              display: "$WF_9_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 38,
              isActive: true,
              field: "SupExtension",
              display: "$WF_10_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompensationEventsAcceptanceOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "1",
              display: "Is a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "0",
              display: "Is not a compensation event",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 104,
      title: "Programme",
      workflows: [
        {
          id: 14,
          title: "$SUPPLIER_NAME Programme",
          notificationName: "Programme",
          abbreviation: "$SUPPLIER_ABBREVIATION-Programme-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "ReasonLabel",
              display: "Reason for any change to planned Delivery",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "ChangeLabel",
              display: "Change in any other Key Date, Delivery Date for a section or other important project milestone in period and reasons why",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "MainProgressLabel",
              display: "Main progress achieved in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "KeyActivitiesLabel",
              display: "Key activities forecast in next four weeks",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "SummaryLabel",
              display: "Summary of critical path",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "ChangesLabel",
              display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "CompensationLabel",
              display: "Compensation events added to programme this period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "NotificationClause",
              display: "Please find attached programme for acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ReplyRejectReasonLabel",
              display: "The $SUPPLIER_NAME’s programme is not accepted for the following reasons",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "ReplyNotificationClause",
              display: "You are notified that the $SUPPLIER_NAME’s Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "DashboardPlannedCompletionLabel",
              display: "Planned Delivery shown on the latest Accepted Programme",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "ReferenceLabel",
              display: "Programme Reference",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyRejectOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "plansnotpractical",
              display: "The $SUPPLIER_NAME’s plans which it shows are not practicable",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "missingcontractrequires",
              display: "It does not show the information which this contract requires",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "notrepresentplan",
              display: "It does not represent the $SUPPLIER_NAME’s plans realistically",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "notcomply",
              display: "It does not comply with the Scope",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "DashboardDisplayPlannedCompletionOnLatest",
          values: [
            {
              id: 1,
              isActive: true,
              field: "DashboardDisplayPlannedCompletionOnLatest",
              display: "Active-Inactive state indicates weather (Planned Completion shown on the latest Accepted Programme) is displayed on dasboard",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "Fields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PreviousPlanned",
              display: "Previous Planned Delivery",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PlannedCompletion",
              display: "Date of Planned Delivery this period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Reason",
              display: "Reason for any change to Planned Completion",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Change",
              display: "Change in any other Key Date, Sectional Completion or other important project milestone in period and reasons why",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "MainProgress",
              display: "Main progress achieved in period",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "KeyActivities",
              display: "Key activities forecast in next four weeks",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "Summary",
              display: "Comments on the programme update",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "Changes",
              display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "Compensation",
              display: "Compensation events added to programme this period",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 14,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 14,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 14,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 14,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_14",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 14,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_14_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 105,
      title: "Notifications",
      workflows: [
        {
          id: 15,
          title: "$PM_NAME Notifications",
          notificationName: "Notification",
          abbreviation: "$PM_ABBREVIATION-Notification-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"]]"
          }
        },
        {
          id: 16,
          title: "$SUPPLIER_NAME Notifications",
          notificationName: "Notification",
          abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "PmClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "13.2 change of address for communications",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "13.5 of an agreement to extend the period for reply for a communication (excluding compensation events periods)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "14.2 of the cancellation of a delegation",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "17.1 of an ambiguity or inconsistency",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_4",
                  timePeriod: "PM_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 25,
              isActive: true,
              field: "",
              display: "17.2 of an illegal or impossible requirement",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "",
              display: "23.2 of an assessment of the amount to be paid as the $SUPPLIER_NAME failed to provide something",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "25.2 of a requirement to allow access to Others",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: true,
              field: "",
              display: "26.1 of an intent to transfer the contract or any rights under it",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "40.3 of a test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 24,
              isActive: false,
              field: "",
              display: "40.3 of the result of a test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "40.6 of an assessment of the amount to be paid for repeating a test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "61.6 that an assumption on which a compensation event quotation is based was wrong",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "",
              display: "88.5 of a matter which is the $SUPPLIER_NAME's liability",
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: false,
              field: "",
              display: "90.1 of the issue of a termination certificate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: true,
              field: "",
              display: "90.1 of a wish to terminate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "",
              display: "91.2 of a default/of the $SUPPLIER_NAME having not put right a default",
              overrideResources: null,
              postActions: null
            },
            {
              id: 20,
              isActive: true,
              field: "",
              display: "91.3 of a default/of the $SUPPLIER_NAME having not put right a default",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              isActive: true,
              field: "",
              display: "Other notification",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SupplierClauses",
          values: [
            {
              id: 7,
              isActive: true,
              field: "",
              display: "13.2 change of address for communications",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "",
              display: "17.1 of an ambiguity or inconsistency",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_4",
                  timePeriod: "PM_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 10,
              isActive: true,
              field: "",
              display: "17.2 of an illegal or impossible requirement",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "",
              display: "26.1 of an intent to transfer the contract or any rights under it",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "31.3 of a failure to respond to a Programme submission",
              effect: "PROG_DEEM_START_INTERVAL",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "42.1 that goods have passed a test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "61.4 of a failure to respond to a compensation event notification",
              effect: "CEN_DEEM_START_INTERVAL",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "62.6 of a failure to reply to a quotation",
              effect: "DEEM_START_INTERVAL",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "64.4 of a failure to assess a compensation event",
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "90.1 of a wish to terminate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "Other notification",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 4,
              isActive: true,
              field: "Client",
              display: "$WF_57_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PM",
              display: "$WF_15_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Supervisor",
              display: "$WF_16_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_17_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "PmToSupervisor",
              display: "$WF_58_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "PmToClient",
              display: "$WF_59_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "SupplierToSupervisor",
              display: "$WF_81_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "SupervisorToPm",
              display: "$WF_60_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "ClientToClient",
              display: "$WF_64_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "PmToPm",
              display: "$WF_63_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "SupplierToSupplier",
              display: "$WF_65_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "SupervisorToSupervisor",
              display: "$WF_66_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 106,
      title: "Submissions",
      workflows: [
        {
          id: 18,
          title: "$SUPPLIER_NAME Submissions",
          notificationName: "Submission",
          abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Support\"]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 49,
          title: "$PM_NAME Submissions",
          notificationName: "Submission",
          abbreviation: "$PM_ABBREVIATION-Submission-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "IssueClausesPM",
          values: [
            {
              id: 1,
              isActive: true,
              field: "",
              display: "86.1 of policies and certificates for insurances provided by the $CLIENT_NAME",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "IssueClauses",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "21.2 particulars of design",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 13,
              isActive: true,
              field: "",
              display: "21.3 parts of particulars of design",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "",
              display: "24.2 the name of a proposed subcontractor",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: true,
              field: "",
              display: "40.2 a quality policy statement",
              overrideResources: null,
              postActions: null
            },
            {
              id: 16,
              isActive: true,
              field: "",
              display: "40.2 a quality plan",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "",
              display: "44.1 proposal to accept a Defect",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "84.1 insurance policies",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "",
              display: "X4.1 a parent company guarantee",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "X13.1 a performance bond",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: true,
              field: "",
              display: "X14.2 an advance payment bond",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: true,
              field: "",
              display: "X20.2 a report of performance",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 11,
              isActive: true,
              field: "",
              display: "X20.3 proposals for improving performance",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 17,
              isActive: true,
              field: "",
              display: "X29.4(1) of a first climate change plan for acceptance",
              applyReplyPeriod: true,
              replyPeriod: 21,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 19,
              isActive: true,
              field: "",
              display: "X29.4(4) of a revised climate change plan for acceptance",
              applyReplyPeriod: true,
              replyPeriod: 21,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "",
              display: "X29.11(1) of a proposal to change the Subcontract Scope to reduce the impact on climate change",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              isActive: true,
              field: "",
              display: "X29.12(1) of a report of performance against the targets in the Performance Table",
              applyReplyPeriod: false,
              noReply: true,
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: true,
              field: "",
              display: "X29.12(2) of a proposal for improving performance for acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 12,
              isActive: true,
              field: "",
              display: "Other submission",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 18,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 18,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 18,
              isActive: false,
              field: "NOT_ACCEPTED",
              display: "Not accepted (not used as resubmission is always required under 13.4)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 18,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required in accordance with clause 13.4",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_18",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 18,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              wfid: 49,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              wfid: 49,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              wfid: 49,
              isActive: true,
              field: "NOT_ACCEPTED",
              display: "Not accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              wfid: 49,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "PM",
                  actionType: "WF_49",
                  timePeriod: "PM_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 10,
              wfid: 49,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_18_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PM",
              display: "$WF_49_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 107,
      title: "Submissions (with quote)",
      workflows: [
        {
          id: 19,
          title: "$SUPPLIER_NAME  Submissions (wq)",
          notificationName: "Submission",
          abbreviation: "$SUPPLIER_ABBREVIATION-SubmissionWQ-",
          notify: true,
          replyEnabled: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "PM_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Support\"]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CostEffectLabel",
              display: "Cost effect on total of the prices",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "DaysEffectLabel",
              display: "Number of days effect to the Delivery Date",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProposalClauses",
          values: [
            {
              id: 6,
              isActive: true,
              field: "",
              display: "16.1 for a change in Scope to reduce the amount",
              applyReplyPeriod: true,
              replyPeriod: 28,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "35.1 for acceleration to achieve Delivery before the Delivery Date",
              applyReplyPeriod: true,
              replyPeriod: 21,
              noReply: false,
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "45.2 for acceptance of a Defect",
              applyReplyPeriod: false,
              noReply: false,
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedReplyOptions",
          values: [
            {
              id: 1,
              wfid: 19,
              isActive: true,
              field: "ACCEPT",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              wfid: 19,
              isActive: false,
              field: "ACCEPT_WITH_COMMENTS",
              display: "Accepted with comments",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              wfid: 19,
              isActive: false,
              field: "NOT_ACCEPTED",
              display: "Not accepted (not used as resubmission is always required under 13.4)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 19,
              isActive: true,
              field: "NOT_ACCEPTED_RESUBMIT",
              display: "Not accepted - resubmission required in accordance with clause 13.4",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_19",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 5,
              wfid: 19,
              isActive: false,
              field: "NO_REPLY_REQUIRED",
              display: "Reply not required",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_19_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 108,
      title: "Payments",
      workflows: [
        {
          id: 20,
          title: "$PM_NAME Payment Certificates",
          notificationName: "Payment Certificate",
          abbreviation: "$PM_ABBREVIATION-Payment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 21,
          title: "$SUPPLIER_NAME Payment Applications",
          notificationName: "Payment Application",
          abbreviation: "$SUPPLIER_ABBREVIATION-Payment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CumulativePriceLabel",
              display: "Lump sums and quantities from the Price Schedule for work completed",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PlusAmountsSupplierLabel",
              display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "LessAmountsSupplierLabel",
              display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TaxSupplierLabel",
              display: "Tax which the law requires the Employer to pay to the $SUPPLIER_NAME",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "WarningBanner",
              display: "The first assessment date is no later than the assessment interval after the starting date. Subsequent assessment dates are the assessment interval after the previous assessment until 4 weeks after the last defects date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "RegisterAppliedByCaption",
              display: "Submitted by",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "RegisterCertifiedByCaption",
              display: "Submitted by",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaxEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "TaxEnabled",
              display: "Active-Inactive state indicates tax field will be included in notification forms",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ApplicationTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "INTERIM",
              display: "50.2 application for payment",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: true,
              field: "FINAL",
              display: "53.2 assessment of the final amount due",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "TERMINATION",
              display: "Termination",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "SUPPLEMENTARY",
              display: "Supplementary",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "DRAFT",
              display: "Draft",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "EXTRA",
              display: "Extra",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "OTHER",
              display: "Other",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PaymentTypes",
          values: [
            {
              id: 2,
              isActive: true,
              field: "INTERIM",
              display: "51.1 payment certificate within one week of assessment date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 1,
              isActive: true,
              field: "FINAL",
              display: "53.1 final payment certificate",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "SUPPLEMENTARY",
              display: "Supplementary",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "DRAFT",
              display: "Draft",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: false,
              field: "EXTRA",
              display: "Extra",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "OTHER",
              display: "Other",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 119,
      title: "Other Assessments",
      workflows: [
        {
          id: 77,
          title: "$PM_NAME Assessments (excluding CE's and Payments)",
          notificationName: "Assessment",
          abbreviation: "$PM_ABBREVIATION-Other-Assessment-",
          notify: true,
          financialLimitEnabled: false,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: []
        },
        {
          replacementKey: "ActionReminders",
          values: []
        },
        {
          replacementKey: "FieldsPM",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Subject",
              display: "Subject",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Type",
              display: "Type",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Description",
              display: "Description",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "EffectContractPrice",
              display: "Affect contract price",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "Amount",
              display: "Amount",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "EffectContractCompletion",
              display: "Affect contract date(s)",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "Days",
              display: "Time",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ClausesPM",
          values: [
            {
              id: 2,
              isActive: true,
              field: "",
              display: "23.2 of an assessment of the amount to be paid as the $SUPPLIER_NAME failed to provide something",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "",
              display: "41.6 of the cost incurred by the $CLIENT_NAME in repeating a test or inspection",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "46.1 of the cost to the $CLIENT_NAME of having a Defect corrected",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "",
              display: "46.2 of the cost the $SUPPLIER_NAME would incur in correcting a Defect",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "",
              display: "51.3 of interest on a corrected payment certificate",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 14,
              isActive: true,
              field: "",
              display: "85.1 of the cost of insurance provided by  the $CLIENT_NAME",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 15,
              isActive: false,
              field: "",
              display: "86.3 of the cost of insurance provided by the $SUPPLIER_NAME",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 18,
              isActive: true,
              field: "",
              display: "X1.3 of the price adjustment added to the amount due",
              effect: "EFFECT_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 21,
              isActive: true,
              field: "",
              display: "X7.1 of the amount of delay damages",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 22,
              isActive: true,
              field: "",
              display: "X14.1 of the amount of advanced payment",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 23,
              isActive: true,
              field: "",
              display: "X14.3 of the amount of repayment of advanced payment",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 25,
              isActive: true,
              field: "",
              display: "X17 of the amount of low performance damages",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            },
            {
              id: 26,
              isActive: true,
              field: "",
              display: "X20.4 of the amount payable for meeting a target on the incentive schedule",
              effect: "NOEFFECT_COMPLETION_PRICE",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 117,
      title: "Other Certificates",
      workflows: [
        {
          id: 68,
          title: "$PM_NAME Certificates",
          notificationName: "Certificate",
          abbreviation: "$PM_ABBREVIATION-Certificate-",
          notify: true,
          replyEnabled: false,
          assetFieldsEnabled: false,
          replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
          replyPeriod: 0,
          resubmitPeriodOption: "PM_REPLY_PERIOD",
          resubmitPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PmCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SupplierCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "ClientCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "SupervisorCertificateText",
              display: "",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "SectionalCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Sectional Completion Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TakingOverFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Taking Over Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "DefectsFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TerminationFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "OtherFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "TaskOrderCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ProjectOrderCompletionFields",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CertifiedDate",
              display: "Certified Date",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Description",
              display: "Details",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "Works",
              display: "Outstanding Works",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "Defects",
              display: "Outstanding Defects",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ReplyOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Accepted",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Not Accepted",
              display: "Not Accepted",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "PMCertTypes",
          values: [
            {
              id: 1,
              isActive: false,
              field: "",
              display: "30.2 Completion Certificate",
              effect: "COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: false,
              field: "",
              display: "X5 30.2 Sectional Completion Certificate",
              effect: "SECTIONAL_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: false,
              field: "",
              display: "35.3 Taking Over Certificate",
              effect: "TAKING_OVER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 9,
              isActive: false,
              field: "",
              display: "43.3 Defects Certificate (NEC3 ECC)",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: false,
              field: "",
              display: "44.3 Defects Certificate",
              effect: "DEFECTS",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "",
              display: "90.1 Termination Certificate",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 10,
              isActive: false,
              field: "",
              display: "X19.1 Termination Certificate (NEC4 TSC)",
              effect: "TERMINATION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: false,
              field: "",
              display: "Other Certificate",
              effect: "OTHER",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: false,
              field: "",
              display: "Task Order Completion",
              effect: "TASK_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: false,
              field: "",
              display: "Project Order Completion",
              effect: "PROJECT_ORDER_COMPLETION",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "CompletionChangesStateEnabled",
          values: [
            {
              id: 1,
              isActive: true,
              field: "CompletionChangesStateEnabled",
              display: "Indicate whether communication of a Completion Certificate should change the contract state",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "PM",
              display: "$WF_68_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Supplier",
              display: "$WF_69_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Client",
              display: "$WF_70_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "Supervisor",
              display: "$WF_71_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 109,
      title: "Quality Management",
      workflows: [
        {
          id: 48,
          title: "$PM_ABBREVIATION Tests & Inspections",
          notificationName: "Test / Inspection",
          abbreviation: "$PM_ABBREVIATION-Test-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "NOTIFICATION_DATE",
          replyPeriod: 0,
          notifyingParty: "PM",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 25,
          title: "$SUPPLIER_NAME Tests & Inspections",
          notificationName: "Test / Inspection",
          abbreviation: "$SUPPLIER_NAME-Test-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "NOTIFICATION_DATE",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Support\"]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        },
        {
          id: 23,
          title: "$PM_ABBREVIATION Defect Notifications",
          notificationName: "Defect Notification",
          pageTitle: "$PM_ABBREVIATION Defect Notification",
          abbreviation: "$PM_ABBREVIATION-Defect-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 24,
          title: "$SUPPLIER_NAME Defect Notifications",
          notificationName: "Defect Notification",
          abbreviation: "$SUPPLIER_NAME-Defect-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          actioningParty: "PM",
          resolveActioningParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
            resolveActionTab: {
              resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            }
          }
        },
        {
          id: 26,
          title: "Master Defect Register",
          notificationName: "Defect Notification",
          abbreviation: "Defect",
          overrideResources: null,
          userFilters: {
            accessFilter: "null"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "InstructionClauseLabel",
              display: "You are instructed to search for a Defect as follows",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SupervisorClauseLabel",
              display: "You are notified of the following Defect",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "SupplierClauseLabel",
              display: "You are notified of the following Defect",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "TestsClauseLabel",
              display: "You are notified of the following test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "ClosureReasonLabel",
              display: "Reason for closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "InstructionTypeLabel",
              display: "Type",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ClosureReasonOptions",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Accepted",
              display: "Accepted",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "Corrected",
              display: "Corrected",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "NoDefect",
              display: "Not a Defect",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "UnifiedClauses",
          values: [
            {
              id: 3,
              wfid: 22,
              isActive: true,
              field: "",
              display: "43.1 Instruction to search for a Defect",
              overrideResources: null,
              postActions: [
                {
                  askUser: false,
                  daysForAction: 0,
                  action: "CREATE",
                  ownerParty: "SUPPLIER",
                  actionType: "WF_24",
                  timePeriod: "SUPPLIER_REPLY_PERIOD"
                }
              ]
            },
            {
              id: 1,
              wfid: 23,
              isActive: true,
              field: "",
              display: "43.2 Notification of a Defect",
              overrideResources: null,
              postActions: []
            },
            {
              id: 2,
              wfid: 24,
              isActive: true,
              field: "",
              display: "43.2 Notification of a Defect",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              wfid: 25,
              isActive: true,
              field: "",
              display: "41.3 Notification of a test or inspection",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              wfid: 48,
              isActive: true,
              field: "",
              display: "41.3 Notification of a test or inspection",
              overrideResources: null,
              postActions: null
            }
          ]
        },
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Instruction",
              display: "$WF_22_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "SuperDefect",
              display: "$WF_23_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 8,
              isActive: true,
              field: "SupplierDefect",
              display: "$WF_24_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 3,
              isActive: true,
              field: "Inspection",
              display: "$WF_25_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 4,
              isActive: true,
              field: "SupervisorTestAndInspection",
              display: "$WF_47_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 5,
              isActive: true,
              field: "PMTestAndInspection",
              display: "$WF_48_TITLE awaiting closure",
              overrideResources: null,
              postActions: null
            },
            {
              id: 6,
              isActive: true,
              field: "PMNCProposal",
              display: "$WF_54_TITLE awaiting acceptance",
              overrideResources: null,
              postActions: null
            },
            {
              id: 7,
              isActive: true,
              field: "NonConformity",
              display: "$WF_55_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 110,
      title: "Delegated Actions",
      workflows: [
        {
          id: 27,
          title: "$PM_NAME Delegated Actions",
          notificationName: "Delegated Action",
          abbreviation: "$PM_ABBREVIATION-Action-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 28,
          title: "$SUPPLIER_NAME Delegated Actions",
          notificationName: "Delegated Action",
          abbreviation: "$SUPPLIER_ABBREVIATION-Action-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: [
            {
              id: 1,
              isActive: true,
              field: "DelegationClause",
              display: "You are notified that the following specific actions",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 111,
      title: "Records",
      workflows: [
        {
          id: 30,
          title: "$PM_NAME Meetings",
          notificationName: "Meeting",
          abbreviation: "$PM_ABBREVIATION-Meeting-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
              communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 31,
          title: "$SUPPLIER_NAME Meetings",
          notificationName: "Meeting",
          abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 32,
          title: "$SUPPLIER_NAME Site Diary",
          notificationName: "Site Diary",
          abbreviation: "Diary-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        },
        {
          id: 33,
          title: "Weather",
          notificationName: "Weather",
          abbreviation: "Weather-",
          notify: true,
          assetFieldsEnabled: false,
          notifyingParty: "SUPPLIER",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
          }
        }
      ],
      placeholders: []
    },
    {
      id: 112,
      title: "RFI / TQ",
      workflows: [
        {
          id: 34,
          title: "$SUPPLIER_NAME RFI / TQ",
          notificationName: "RFI / TQ",
          abbreviation: "RFI/TQ-",
          notify: true,
          replyEnabled: true,
          assetFieldsEnabled: false,
          replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
          replyPeriod: 0,
          notifyingParty: "SUPPLIER",
          replyingParty: "PM",
          form_IncludeCompanyName: true,
          form_CompanyLogo: "PARTY",
          form_CompanyName: "PARTY",
          notifyAttachments: true,
          replyAttachments: true,
          includePdfjson: false,
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            mainNotice: {
              createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
              communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            },
            replyNotice: {
              saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
              communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
            },
            notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "ActionReminders",
          values: [
            {
              id: 1,
              isActive: true,
              field: "Supplier",
              display: "$WF_34_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            },
            {
              id: 2,
              isActive: true,
              field: "PM",
              display: "$WF_80_TITLE awaiting reply",
              overrideResources: null,
              postActions: null
            }
          ]
        }
      ]
    },
    {
      id: 113,
      title: "Contract Information",
      workflows: [
        {
          id: 39,
          title: "Documents",
          notificationName: "Document",
          abbreviation: "Documents-",
          actioningParty: "PM",
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            }
          }
        },
        {
          id: 44,
          title: "Project Bank Accounts",
          notificationName: "Project Bank Account",
          abbreviation: "BankAccount-",
          actioningParty: "PM",
          overrideResources: null,
          userFilters: {
            accessFilter: "null",
            actionTab: {
              actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
            }
          }
        }
      ],
      placeholders: [
        {
          replacementKey: "Resources",
          values: []
        },
        {
          replacementKey: "ActionReminders",
          values: []
        }
      ]
    }
  ]
};

export default template;